<template>
  <div>
    <!-- <pre>{{sub_repository}}</pre> -->
    <vs-row v-if="currentFolderIndex == 0">
        <template  v-for="(eachImage, index) in import_files">
      <vs-col
        v-if="eachImage.file_type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        :key="index"
        vs-lg="3"
        vs-sm="6"
        vs-xs="12"
      >
        <vs-checkbox
          class="image-select-checkbox"
          v-model="files_selected"
          :vs-value="eachImage"
          
        >
          <!-- {{ eachImage }} -->
          <!-- <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('image')"
          >
            <img
              class="object-contain w-full"
              :src="eachImage.file_path"
              height="200"
            />
            <vs-tooltip text="Add this picture"> </vs-tooltip>
          </vs-card> -->

          <!-- <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('audio')"
          >
            <audio class="w-full" controls>
              <source :src="eachImage.file_path" :type="eachImage.file_type" />
              Your browser does not support the audio element.
            </audio>
          </vs-card>
          <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('video')"
          >
            <video class="w-full" controls>
              <source :src="eachImage.file_path" :type="eachImage.file_type" />
              Your browser does not support the audio element.
            </video>
          </vs-card> -->

          <!-- <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('application/pdf')"
          >
            {{ eachImage.file_name }}
            <span class="material-icons"> picture_as_pdf </span>
          </vs-card> -->

            <vs-card
            class="imageholdercontainer mb-0 text-center"
           
          >
          
            <svg class="excel-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 28.875 0 C 28.855469 0.0078125 28.832031 0.0195313 28.8125 0.03125 L 0.8125 5.34375 C 0.335938 5.433594 -0.0078125 5.855469 0 6.34375 L 0 43.65625 C -0.0078125 44.144531 0.335938 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 29.101563 50.023438 29.402344 49.949219 29.632813 49.761719 C 29.859375 49.574219 29.996094 49.296875 30 49 L 30 44 L 47 44 C 48.09375 44 49 43.09375 49 42 L 49 8 C 49 6.90625 48.09375 6 47 6 L 30 6 L 30 1 C 30.003906 0.710938 29.878906 0.4375 29.664063 0.246094 C 29.449219 0.0546875 29.160156 -0.0351563 28.875 0 Z M 28 2.1875 L 28 6.53125 C 27.867188 6.808594 27.867188 7.128906 28 7.40625 L 28 42.8125 C 27.972656 42.945313 27.972656 43.085938 28 43.21875 L 28 47.8125 L 2 42.84375 L 2 7.15625 Z M 30 8 L 47 8 L 47 42 L 30 42 L 30 37 L 34 37 L 34 35 L 30 35 L 30 29 L 34 29 L 34 27 L 30 27 L 30 22 L 34 22 L 34 20 L 30 20 L 30 15 L 34 15 L 34 13 L 30 13 Z M 36 13 L 36 15 L 44 15 L 44 13 Z M 6.6875 15.6875 L 12.15625 25.03125 L 6.1875 34.375 L 11.1875 34.375 L 14.4375 28.34375 C 14.664063 27.761719 14.8125 27.316406 14.875 27.03125 L 14.90625 27.03125 C 15.035156 27.640625 15.160156 28.054688 15.28125 28.28125 L 18.53125 34.375 L 23.5 34.375 L 17.75 24.9375 L 23.34375 15.6875 L 18.65625 15.6875 L 15.6875 21.21875 C 15.402344 21.941406 15.199219 22.511719 15.09375 22.875 L 15.0625 22.875 C 14.898438 22.265625 14.710938 21.722656 14.5 21.28125 L 11.8125 15.6875 Z M 36 20 L 36 22 L 44 22 L 44 20 Z M 36 27 L 36 29 L 44 29 L 44 27 Z M 36 35 L 36 37 L 44 37 L 44 35 Z"/></svg>
            <p class="text-center">  {{ eachImage.file_name }}</p>
          </vs-card>
        </vs-checkbox>
      </vs-col>
        </template>
    </vs-row>

    <!-- <pre> {{ old_repository }}</pre> -->
    <vs-button type="border" class="mb-4" @click="goBackWard()" v-if="currentFolderIndex > 0" icon="chevron_left"
      ></vs-button
    >

    <vs-card class="folder-card">
      <div
        v-for="(eachSub, index) in sub_repository"
        :key="index"
        class="folder-holder"
      >
        <vs-icon
          class="w-full p-3"
          icon-pack="feather"
          icon="icon-folder"
          @click="goForward(eachSub, sub_repository, index)"
        >
          <span class="ml-2"
            ><b>{{ eachSub.repository_name }}</b></span
          >
        </vs-icon>

        <div
          v-for="(eachImage, index) in eachSub.files"
          :key="index"
          style="width: 350px; margin: 10px;"
        >
          <vs-checkbox
            class="image-select-checkbox"
            v-model="files_selected"
            :vs-value="eachImage"
          >
            <vs-card class="imageholdercontainer mb-0">
              <img
                class="object-contain w-full"
                :src="eachImage.file_path"
                height="200"
              />
              <vs-tooltip text="Add this picture"> </vs-tooltip>
            </vs-card>
          </vs-checkbox>
        </div>
      </div>
    </vs-card>
    <vs-button
      style="position: absolute; right: 50px; bottom: 20px"
      @click="importFiles()"
      v-if="import_files.length > 0"
      >Import {{ files_selected.length }} {{ files_selected.length > 1 ? 'files' : 'file' }}</vs-button
    >
  </div>
</template>

<script>
import { repoDetails } from '@/api/file.js'

export default {
  name: 'ImportBrowserFilesModel',
  props: {
    file_repository_id: {},
    multipleSelect:{
      default:true
    },
    onlyImage:{
      default:false
    }

    
  },
  created () {
    this.fetchFile()
  },
  data () {
    return {
      currentFolderIndex: 0,
      filesInfo: [],
      import_files: [],
      sub_repository: [],
      files_selected: [],
      old_repository: [],
      sub_repository_previous: [],
      activeIndex: null
    }
  },
  methods: {
    goInsideFolder (sub_repository) {
      this.sub_repository = sub_repository
      
    },
    goForward (newFolderData, oldFolderData, index) {
      this.activeIndex = index
      
      this.sub_repository_previous.push(oldFolderData)
      
      this.currentFolderIndex++

      this.sub_repository = newFolderData.sub_repository
    },
    goBackWard () {
      
      
      this.currentFolderIndex--
      this.sub_repository = this.sub_repository_previous[
        this.currentFolderIndex
      ]
    },
    async fetchFile () {
      this.$vs.loading({
        text: 'Please wait while we are fetching'
      })

      try {
        const responseFiles = await repoDetails(
          this.$store.getters.customerId,
          this.file_repository_id
        )
        this.import_files = responseFiles.data.data.repository.files
        this.old_repository = responseFiles.data.data.repository.sub_repository
        this.sub_repository = [...this.old_repository]
      } catch (error) {
        this.showSuccessMessage('error', 'Something Went wrong', 'danger')
      } finally {
        this.$vs.loading.close()
      }
      //   
    },
    importFiles () {
      if (this.files_selected.length > 0) {
        if ((this.multipleSelect) || (!this.multipleSelect && this.files_selected.length === 1)) {

          const fileSelected = this.files_selected.map((ele) => {
            return ele.files_id
          })
          // 

          const fileObject = {
            file_id: fileSelected,
            fileInfo: this.files_selected
          }
          this.$emit('getImportFile', fileObject)
        } else {
          this.showSuccessMessage('error', 'Only Single Select is Allowed', 'danger')

        }
        // 
      } else {
        this.showSuccessMessage('error', 'No Files Selected', 'danger')
      }
      // 
    }
  }
}
</script>

<style>
.excel-svg{
    margin:0 auto;
    fill:rgba(var(--vs-text), 1);
}
.image-select-checkbox .vs-checkbox {
  position: absolute;
  opacity: 0;
}
.image-select-checkbox .con-slot-label {
  width: 100%;
}
.image-select-checkbox input:checked ~ .con-slot-label {
  width: 90%;
  height: 90%;
  margin: 0 auto;
}
.image-select-checkbox input:checked ~ .con-slot-label .imageholdercontainer {
  box-shadow: 0 4px 15px rgba(var(--vs-primary), 1);
}
.folder-card .vs-card--content {
  display: flex;
  flex-wrap: wrap;
}
</style>